module.exports = __webpack_public_path__ + "static/auth0-image-fit-cover-b4a92eb547759298f265d61efe7b5315.png";